import React, { useEffect, useState, useContext, createContext } from 'react';
import { Dimensions } from 'react-native';
import AuthContext from 'app/src/contexts/AuthContext';

// context instance - exported and can be consumed by any child component of UserProvider
export const UserContext = createContext();

const MOBILE_WIDTH = 992;

// This context provider is passed to any and all components requiring this context
export const UserProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  const [initialScale, setInitialScale] =
    useState(Dimensions.get('window').scale);
  const [screenWidth, setScreenWidth] =
    useState(Dimensions.get('screen').width);

  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    setIsMobile(Dimensions.get('window').width <= MOBILE_WIDTH);

    const handleChange = ({ screen, window: win }) => {
      // Moved to another screen
      if (screen.width !== screenWidth) {
        setInitialScale(screen.scale);
        setScreenWidth(screen.width);
      } else {
        const width = win.width / initialScale * win.scale;

        if (width <= MOBILE_WIDTH) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      }
    };

    const subscription = Dimensions.addEventListener('change', handleChange);

    return () => {
      subscription.remove();
    };
  }, [setIsMobile, screenWidth, initialScale]);

  // Wrap the parent component, then each child anywhere in the application
  //  can subscribe to the data in the provider and subsequent updates, making both setters and
  //  getters available throughout.
  return (
    <UserContext.Provider
      value={{
        isMobile,
        screenWidth,
        userId: auth?.user?.id,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;